export function getDialogStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        main: {
            borderRadius: effects.roundedCorner8,
            boxShadow: effects.elevation64,
        },
    };
    return styles;
}
export function getDialogContentStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        topButton: {
            '&:hover': {
                '.ms-Dialog-button': {
                    borderRadius: effects.roundedCorner4,
                },
            },
        },
        button: {
            borderRadius: effects.roundedCorner4,
        },
    };
    return styles;
}
//# sourceMappingURL=Dialog.styles.js.map